import React from 'react';
import InputFieldProperties from './FieldProperties/InputFieldProperties';
import SignatureProperties from './FieldProperties/SignatureProperties';
import NumberFieldProperties from './FieldProperties/NumberFieldProperties';

const FieldOptions = (props) => {
    const { element = {} } = props;

    switch (element?.key) {
        case 'InputField':
            return <InputFieldProperties {...props} />;
        case 'NumberField':
            return <NumberFieldProperties {...props} />;
        case 'Signature':
            return <SignatureProperties {...props} />;
        default:
            return null;
    }
};

export default FieldOptions;
